/**
 * Downloads an attachment by opening the file URL in a new window
 * @param documentId - The ID of the document to download
 */
export function downloadAttachment(documentId: string): void {
  const url = window.Silverfin.Routes.file_document_path(
    window.Silverfin.currentFirmId,
    window.Silverfin.currentCompanyId,
    documentId
  )

  window.open(url)
}

/**
 * Opens an attachment preview in a new tab with current ledger context
 * @param documentId - The ID of the document to preview
 */
export function previewAttachment(documentId: string): void {
  const url = window.Silverfin.Routes.document_path(
    window.Silverfin.currentFirmId,
    window.Silverfin.currentCompanyId,
    documentId,
    { current_ledger_id: window.Silverfin.currentLedgerId() }
  )

  window.open(url, '_blank')
}
